<ng-container [ngSwitch]="buttonMode()">
  <button
    *ngSwitchCase="'callback'"
    class="rd-button focus-link"
    [ngClass]="buttonTheme"
    [attr.aria-label]="ariaLabel"
    [attr.disabled]="isDisabled ? true : null"
    [attr.type]="buttonType"
    (click)="clickFn.emit($event)">
    <img *ngIf="iconPath" alt="" class="btn-icon" [src]="iconPath" />
    <span class="rd-button-text">
      <ng-container *ngIf="!!buttonText"> {{ buttonText }} </ng-container>
      <ng-container *ngTemplateOutlet="buttonContent"> </ng-container>
    </span>
  </button>

  <a
    *ngSwitchCase="'internalURL'"
    class="rd-button focus-link"
    [ngClass]="buttonTheme"
    [routerLink]="redirectURL"
    [queryParams]="queryParams"
    [attr.aria-label]="ariaLabel"
    [attr.role]="roleType">
    <img *ngIf="iconPath" class="btn-icon" [src]="iconPath" />
    <span class="rd-button-text">
      <ng-container *ngIf="!!buttonText"> {{ buttonText }} </ng-container>
      <ng-container *ngTemplateOutlet="buttonContent"> </ng-container>
    </span>
  </a>

  <a
    *ngSwitchCase="'externalURL'"
    class="rd-button focus-link"
    [ngClass]="buttonTheme"
    [href]="redirectURL"
    [attr.target]="isTargetBlank ? '_blank' : null"
    [attr.rel]="isTargetBlank ? 'noopener noreferrer' : null"
    [attr.aria-label]="ariaLabel"
    [attr.role]="roleType">
    <img *ngIf="iconPath" class="btn-icon" [src]="iconPath" />
    <span class="rd-button-text">
      <ng-container *ngIf="!!buttonText"> {{ buttonText }} </ng-container>
      <ng-container *ngTemplateOutlet="buttonContent"> </ng-container>
    </span>
  </a>
</ng-container>
